import directive from './src/directive';
import service from './src/index';
export default {
  install: function install(Vue) {
    Vue.use(directive);
    Vue.prototype.$pzLoading = service;
  },
  directive: directive,
  service: service
};